import React from "react";
import Layout, { Main } from "../Layout";
import { Col, Row, Table } from "reactstrap";
import { useLocation } from "react-router-dom";
import { formatDate } from "../utils/DateFormater";
import { useCustomTheme } from "../Context/CustomThemeProvider";
import useCelebritiesStore from "../store/CelebritiesStore";

const Balance = () => {
  const { theme } = useCustomTheme();
  const location = useLocation();
  const balance = location?.state?.balance;
  const { celebrities } = useCelebritiesStore();
  return (
    <Layout backPath={{ pathname: "/admin" }} celebrities={celebrities.items}>
      <Main>
        <Row>
          <Col>
            <h1 className={"fs-2"}>
              Le solde de votre portefeuille à ce jour est de :
            </h1>
            <p>
              Montant total : {balance.totalAmount}{" "}
              {balance.userCurrency.toUpperCase()}
              {balance.totalAmount > 0 ? "s" : ""}
              <sup>*</sup>
            </p>
            <p>
              Commission : {balance.charge} {balance.userCurrency.toUpperCase()}
              {balance.charge > 0 ? "s" : ""}
            </p>
            <p>
              Montant net à payer : {balance.amountToPay}{" "}
              {balance.userCurrency.toUpperCase()}
              {balance.amountToPay > 0 ? "s" : ""}
            </p>
            <p className={"mt-3 fst-italic fw-bold"}>
              <sup>*</sup>Ce montant est calculé sur la base des commandes
              livrées ci-dessous :
            </p>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className={"overflow-x-scroll hide-scroll-bar"}>
            <Table striped dark={theme === "dark"}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Demandeur</th>
                  <th>Bénéficiaire</th>
                  <th>Raison</th>
                  <th>Statut</th>
                  <th>Prix</th>
                </tr>
              </thead>
              <tbody>
                {!balance.paymentDetails.orders ||
                balance.paymentDetails.orders.length === 0 ? (
                  <tr>
                    <td colSpan={7}>Aucune information disponible.</td>
                  </tr>
                ) : (
                  balance.paymentDetails.orders.map((order, index) => (
                    <tr key={index}>
                      <td>
                        {formatDate(new Date(order.createdAt), "Y-MM-dd")}
                      </td>
                      <td>{order.type}</td>
                      <td>{order.dedicaceFrom}</td>
                      <td>{order.dedicaceTo}</td>
                      <td>{order.orderReason}</td>
                      <td>
                        {order.deliveryStatus === "in_progress" && "non traité"}
                        {order.deliveryStatus === "processed" && "traité"}
                        {order.deliveryStatus === "accepted" && "validé"}
                        {order.deliveryStatus === "rejected" && "refusé"}
                        {order.deliveryStatus === "delivered" && "livré"}
                      </td>
                      <td>{order.price}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Main>
    </Layout>
  );
};

export default Balance;
